import { render, staticRenderFns } from "./modal-detalhe-agrupamento.vue?vue&type=template&id=1d812812&scoped=true"
import script from "./modal-detalhe-agrupamento.vue?vue&type=script&lang=ts"
export * from "./modal-detalhe-agrupamento.vue?vue&type=script&lang=ts"
import style0 from "./modal-detalhe-agrupamento.vue?vue&type=style&index=0&id=1d812812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d812812",
  null
  
)

export default component.exports